import { globalGetService } from '@/utils/globalApiServices';
import { CspSuggestionParams, CspSuggestion } from './types';

export const getCspSuggestions = async (
  queries: CspSuggestionParams = {}
): Promise<CspSuggestion[]> => {
  const response = await globalGetService('mno/csp/suggestions', queries);
  return response?.ok ? response.data : [];
};
